import { RND } from "../../../../../Utils/RND";
import { rnd } from "../../../../../Game";

export class Settings {
    /**
     * (RO) Minimalni prodleva pro aktivaci dalsi prekazky vs ms
     */
    get obsMinActDelay(): number { return this._obsMinActDelay; }
    private _obsMinActDelay: number;

    /**
     * (RO) Maximalni prodleva pro aktivaci dalsi prekazky v ms
     */
    get obsMaxActDelay(): number { return this._obsMaxActDelay; }
    private _obsMaxActDelay: number;

    /**
     * (RO) Rychlost pohybu prekazek vjednotkach za s
     */
    get obsMoveSpeed(): number { return this._obsMoveSpeed; }
    private _obsMoveSpeed: number;

    /**
     * (RO) Smer pohybu prekazek
     */
    get obsMoveDir(): number { return this._obsMoveDir; }
    private _obsMoveDir: number;

    /**
     * Pravdepodobnost pro jednotlive typy prekazek (cela cisla v rozsahu 0 az X, pokud 0, tak se dany typ prekazky nepouzije)
     */
    private _obsTypeProb: number[];

    /**
     * Soucet pravdepodobnosti vsech typu
     */
    private _obsTypeTotProb: number;

    //-------------------------------------------------------------------------
    /**
     * Konstruktor
     * @param obsMinDelay Minimalni prodleva mezi prekazkami v ms
     * @param obsMaxDelay Maximalni prodleva mezi prekazkami v ms
     * @param obsSpeed Rychlost pohybu prekazek v jednotkach za s
     * @param obsDir Smer pohybu prekazek (1 = vpravo, 0 = vybere se nahodne, -1 = vlevo)
     * @param obsTypeProb Pravdepodobnost pro jednotlive typy prekazek (cela cisla v rozsahu 0 az X, pokud 0, tak se dany typ prekazky nepouzije)
     */
    //-------------------------------------------------------------------------
    constructor(obsMinDelay: number, obsMaxDelay: number, obsSpeed: number, obsDir: number, obsTypeProb: number[]) {
        this._obsMinActDelay = obsMinDelay;
        this._obsMaxActDelay = obsMaxDelay;
        this._obsMoveSpeed = obsSpeed;

        if ((this._obsMoveDir = obsDir) == 0)
            this._obsMoveDir = rnd.randomBool() ? 1 : -1;

        this._obsTypeProb = obsTypeProb;
        this._obsTypeTotProb = 0;

        obsTypeProb.forEach((val: number) => { this._obsTypeTotProb += val; });
    }

    //-------------------------------------------------------------------------
    /**
     * Vybere typ dalsi prekazky
     */
    //-------------------------------------------------------------------------
    chooseObstacleType(): number {
        let i = rnd.randomIntIn(0, this._obsTypeTotProb - 1);
        let typeId = this._obsTypeProb.length - 1;

        while (this._obsTypeProb[typeId] <= i)
            i -= this._obsTypeProb[typeId--];

        return typeId;
    }
}